import {Component, OnInit} from '@angular/core';
import {Input} from "@angular/core";
import {OwlOptions} from 'ngx-owl-carousel-o';
import {Product} from "../../../../models/product";

@Component({
    selector: 'app-product-options',
    templateUrl: './product-options.component.html',
    styleUrls: ['./product-options.component.css']
})
export class ProductOptionsComponent implements OnInit {
    @Input() productOptions:Product[];

    constructor() {
    }



    ngOnInit(): void {
    }

}
